'use strict';
const angular = require('angular');

export class TaskEditComponent {
  /*@ngInject*/
  constructor(TaskService, $uibModal, User, dialogs, SettingsService) {
    this.TaskService = TaskService;
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.User = User;
    this.SettingsService = SettingsService;

    this.SettingsService.getByName({name: 'custom-fields'}, customFieldSettings => {
      if (customFieldSettings.data.hasOwnProperty("task")) {
        this.customSchema = customFieldSettings.data.task;
        this.customForm = ["*"];
      }
    });

    this.task = {
      priority: 0,
      status: "open"
    };
    this.customFields = {};
    this.users = [];

    this.statusEnum = ["open","closed"];
    this.priorities = [{
      value: 1,
      name: "High"
    },{
      value: 0,
      name: "Normal"
    },{
      value: -1,
      name: "Low"
    }];

    this.dueDatePopupOpened = false;

    this.User.query(data => {
      this.users = data.map(user => {
        return {
          value: user._id,
          name: user.shortName || (user.firstName + ' ' + user.lastName)
        };
      });
    });
  }

  openDueDatePopup() {
    this.dueDatePopupOpened = true;
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        that.ok();
        /*
        var infotxt = (that.config.data) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The task has been "+ infotxt +" successfully");
        dlg.result.then(() => {

        });*/
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.task.customFields = this.customFields || {};

      if (this.config.data) {  // edit
        this.TaskService.update({id: this.task._id}, this.task, onSuccess, onError)
      } else { // new
        this.TaskService.save(this.task, onSuccess, onError);
      }
    }
  }

  userLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'userLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (user) {
        that.task.assignedTo = user._id;
      },
      function () { /* cancel */ }
    );

  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.hasOwnProperty("data")) {
      this.task = angular.copy(this.config.data);

      if (typeof this.task.assignedTo == "object" &&  this.task.assignedTo !== null) {
        this.task.assignedTo = this.task.assignedTo._id;
      }

      this.task.dueDate = new Date(this.task.dueDate);
      this.customFields = this.task.customFields || {};
    } else if (this.config.hasOwnProperty("context")) {
      this.task.context = this.config.context;
    }
  };

  ok() {
    this.close({$value: this.task});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.taskEdit', [])
  .component('taskEdit', {
    template: require('./task-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: TaskEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/task-edit/task-edit.component.js